import React from "react";
import "../Css_files/Homecont2.css"; 
import { FaUserGraduate, FaChalkboardTeacher, FaCertificate, FaLaptop } from "react-icons/fa";

const HomeCont2 = () => {
  return (
    <section id="homecont2">
      <h2>Course Features</h2>
      <p>
        At <strong>Profenaa Technologies Online Learning</strong>, our courses are designed to give you more than just theory. 
        With engaging video lessons, live sessions, practice projects, and certification support, we ensure a complete learning journey. 
        Learn anytime, anywhere, and take advantage of interactive tools, career guidance, and real-world applications that make 
        you job-ready.
      </p>

      <div className="course-features">
        <div className="feature-card">
          <FaUserGraduate />
          <h3>Personalized Learning</h3>
          <p>
            Get one-on-one mentorship and tailored guidance to focus on your strengths, fix weaknesses, 
            and achieve your specific learning goals.
          </p>
        </div>

        <div className="feature-card">
          <FaChalkboardTeacher />
          <h3>Expert-Led Classes</h3>
          <p>
            Learn from industry professionals and certified trainers through live interactive sessions 
            and pre-recorded lessons you can revisit anytime.
          </p>
        </div>

        <div className="feature-card">
          <FaCertificate />
          <h3>Recognized Certifications</h3>
          <p>
            Earn globally recognized certificates upon course completion to showcase your skills and 
            boost your career opportunities.
          </p>
        </div>

        <div className="feature-card">
          <FaLaptop />
          <h3>Flexible Online Access</h3>
          <p>
            Learn from anywhere in the world with 24/7 access to our learning portal. Study at your own pace 
            while balancing work, college, or personal commitments.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HomeCont2;
